import { createBrowserRouter, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Apply from '../pages/Apply';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/apply',
    element: <Apply />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  }
]); 